import {inject} from '@angular/core';
import {ActivatedRouteSnapshot,CanActivateChildFn,CanActivateFn,Router,RouterStateSnapshot} from '@angular/router';
import {DefaultRoutes} from 'src/app/core/routes';
import {AuthService} from '../auth.service';

export const RouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const userRole = authService.user?.rol ?? 'USUARIO';
  const redirectTo = (route.data['redirectTo'] as string) ?? DefaultRoutes.home;
  const user=authService.user;
  if (route.data['roles'] && !route.data['roles'].includes(userRole)) {
    router.navigateByUrl(redirectTo);
    return false;
  }
  const requiredPermission=route.data['requiredPermission'];
  if(requiredPermission) {
    const permissions=user?.editPermissions? user.editPermissions.split(','):[];
    if(!permissions.includes(requiredPermission))
    {
      router.navigateByUrl(DefaultRoutes.home);
      return false;
    }
  }
  return true;
}


export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => RouteGuard(route, state);
